import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import { Box, Container, Stack } from "@mui/material";
import Grid from "@mui/material/Grid2";
import Heading from "../components/Heading";
import { requestGetOne } from "../API/request_server";
import {
  AccessTime,
  CalendarMonth,
  LocationOn,
  Person,
  Groups,
  Description,
} from "@mui/icons-material";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

export default function ViewMeeting() {
  const [_meetingData, _setMeetingData] = useState([]);
  const { id } = useParams();
  useEffect(() => {
    if (id)
      requestGetOne(`meetings/db_get_by_id?meeting_id=${id}`).then((res) => {
        _setMeetingData(res.data);
      });
  }, [id]);

  return (
    <>
      <Box
        sx={{
          py: { xs: 6, md: 2 },
          background: "#f8fafc",
        }}
      >
        <Container>
          <Grid container>
            <Grid size={{ xs: 12, sm: 12, md: 8 }}>
              <Card>
                <CardMedia
                  sx={{ height: 400 }}
                  image={
                    _meetingData.image
                      ? `http://localhost/backend_ptp_admin/${_meetingData.image}`
                      : "favicon.ico"
                  }
                  title="green iguana"
                />
                <CardContent>
                  <Typography gutterBottom variant="h6" component="div">
                    {_meetingData.meeting_title}
                  </Typography>
                  <Typography variant="body2" sx={{ color: "text.secondary" }}>
                    {_meetingData.description}
                  </Typography>
                </CardContent>
              </Card>
            </Grid>

            <Grid
              size={{ xs: 12, md: 4 }}
              sx={{
                pl: { md: 2 },
              }}
            >
              <Box
                sx={{
                  p: 3,
                  borderRadius: 1,
                  backgroundColor: "#f8fafc",
                  border: "1px solid #e0e0e0",
                }}
              >
                <Heading _title="Meeting Information" align="left" />
                <Stack spacing={3}>
                  <Stack direction="row" spacing={2} alignItems="center">
                    <CalendarMonth color="primary" />
                    <Box>
                      <Typography variant="body2" color="text.secondary">
                        Date
                      </Typography>
                      <Typography fontWeight={600}>
                        {_meetingData.date}
                      </Typography>
                    </Box>
                  </Stack>
                </Stack>

                <Stack direction="row" spacing={2} alignItems="center">
                  <AccessTime color="primary" />
                  <Box>
                    <Typography variant="body2" color="text.secondary">
                      Time
                    </Typography>
                    <Typography fontWeight={600}>
                      {_meetingData.date}
                    </Typography>
                  </Box>
                </Stack>

                <Stack direction="row" spacing={2} alignItems="center">
                  <LocationOn color="primary" />
                  <Box>
                    <Typography variant="body2" color="text.secondary">
                      Location
                    </Typography>
                    <Typography fontWeight={600}>
                      {_meetingData.location}
                    </Typography>
                  </Box>
                </Stack>

                <Stack direction="row" spacing={2} alignItems="center">
                  <Person color="primary" />
                  <Box>
                    <Typography variant="body2" color="text.secondary">
                      Organizer
                    </Typography>
                    <Typography fontWeight={600}></Typography>
                  </Box>
                </Stack>

                <Stack direction="row" spacing={2} alignItems="center">
                  <Groups color="primary" />
                  <Box>
                    <Typography variant="body2" color="text.secondary">
                      Total Attendees
                    </Typography>
                    <Typography fontWeight={600}></Typography>
                  </Box>
                </Stack>
              </Box>
            </Grid>
          </Grid>
        </Container>
      </Box>
    </>
  );
}
